const play_btn = document.querySelectorAll(".js-play-video");

if (play_btn.length > 0) {
  play_btn.forEach((item) => {
    let video = item.parentNode.querySelector("video");
    let youtube = item.parentNode.querySelector("iframe");
    item.addEventListener("click", () => {
      item.classList.add("is-hidden");
      if (video !== null) video.play();
      if (youtube !== null) youtube.src += "&autoplay=1";
      console.log(youtube);
    });
  });
}
